import { Type } from "class-transformer";
import { FrontendForm } from "src/modules/sm-base/netgen/FrontendForm";

export class DeveloperAction {
    id: string;
    name: string;
    @Type(() => FrontendForm)
    form: FrontendForm;
}
